/**
 * @fileoverview Zod schema for the TenantDetailModal "Add Activity" form.
 * @description Every issue message is a translation key (per this repo's i18n rule for
 * validators), translated only at the display call site in TenantActivityPanel.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { z } from 'zod'

export const addActivityFormSchema = z.object({
  type: z.enum(['Call', 'Meeting', 'Demo', 'Note', 'Follow-up']),
  details: z.string().trim().min(1, 'sales.tenantDetail.activities.errors.detailsRequired'),
  scheduledAt: z.string().trim().optional(),
})

export type AddActivityFormValues = z.infer<typeof addActivityFormSchema>
